// src/data/carrierAnswerLimits.js
//
// THE CARRIER'S ANSWER CLOCKS - the numbers appealLadder.js refuses to invent, extracted from the
// agreements' own words and CONFIRMED by Bob on 2026-09-25.
//
// appealLadder.js (ruling 177) computes the carrier's answer due date from a `limits` object and
// deliberately supplies no day-count of its own, because 60 is the on-property FILING window (a
// different clock) and a date guessed from the wrong clock is worse than none. This module is where
// the real numbers live. Each one resolves to a verbatim quote at a cited line in
// data\YCP_VIOLATION_RULE_MAP.csv, which VIO-1 proves every run - a projection of the record, never
// a second source (§XI).
//
// CONFIRMED 2026-09-25 (task list §414/§415; four SME confirmations in
// data\YCP_CARRIER_ANSWER_CLOCKS_2026-09-25.md): initial answer 60 calendar days (Amtrak, CSX,
// Conrail-YM, D&H/CP), 30 (Conrail Mechanical Supervisors); CSX answers an APPEAL in 75; calendar
// days; governing agreement by applicableAgreement; the conference-decision clock (from "date
// discussed") is its own act.
//
// THE APPEAL FIGURE, DECIDED BY THE PRINCIPLE (member first, then platform):
//   - Where an agreement names a DISTINCT appeal-level number, it is here (CSX: 75).
//   - Where it does not, appealAnswerDays is null and appealLadder.js FALLS BACK TO THE INITIAL
//     number - because the successive-officer clause (CLAIM-successive-officer-handling) recurs the
//     same limit at each appeal step, so the initial figure IS the appeal figure. Null here means
//     "no distinct figure - the initial recurs", NOT "unknown". The member's default-allowance
//     protection stays live on every appeal step; it never goes dark for want of a separate number.
import { CARRIER_ANSWER_LIMITS } from './carrierAnswerLimitsTable';   // section 739: the table is installation content (ruling 321)
import { canonicalAgreementKey } from './claimRequirements';
export { CARRIER_ANSWER_LIMITS };


// The full confirmed record for an agreement, by the claim's applicableAgreement (aliases resolved
// through claimRequirements.js). null when the agreement is unknown to this table.
export function carrierAnswerRecordFor(applicableAgreement) {
  const key = canonicalAgreementKey(applicableAgreement);
  return (key && CARRIER_ANSWER_LIMITS[key]) || null;
}

// The `limits` object appealLadder.js consumes for a claim's agreement. It carries BOTH day-counts;
// appealLadder.js.answerDue picks the appeal figure only when the clock started with an `appealed`
// act AND appealAnswerDays is a number, otherwise the initial figure stands (the successive-officer
// recurrence). A missing agreement yields nulls - the module's honest "unknown", never a guess.
// appealAnswerStated (forensic audit 2026-10-16): false where the agreement states NO carrier answer clock on appeal
// (Amtrak 29(f), Conrail 4-K-1(f), Conrail M/S 14(A), Soo Line 25) - the recurrence is then NOT applied.
export function carrierLimits(applicableAgreement) {
  const a = carrierAnswerRecordFor(applicableAgreement);
  if (!a) {
    return { carrierAnswerDays: null, appealAnswerDays: null, conferenceDecisionDays: null, appealAnswerStated: true,
             provision: 'CLAIM-carrier-response-limits',
             defaultAllowanceProvision: 'CLAIM-carrier-response-limits-default-allowance' };
  }
  return {
    carrierAnswerDays: Number.isFinite(a.initialDays) ? a.initialDays : null,
    appealAnswerDays: Number.isFinite(a.appealDays) ? a.appealDays : null,
    conferenceDecisionDays: Number.isFinite(a.conferenceDecisionDays) ? a.conferenceDecisionDays : null,
    appealAnswerStated: a.appealAnswerStated !== false,
    appealAnswerFrom: a.appealFrom || null,   // forensic audit 2026-10-16: 'receipt' where the appeal answer runs from receipt (CSX)
    provision: a.provision,
    defaultAllowanceProvision: a.defaultAllowanceProvision,
  };
}
